import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { _BoxCutBase as BoxCutBase } from './cssVar/boxCutBase'
import { _BoxCutDefault as BoxCutDefault } from './cssVar/boxCutDefault'
import { GameCardCommonProps } from '../../common.type'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import style from './style.module.scss'
/** 一键控制调试模式 */
const isDebug = window.abcdefg_open
// 警告的bug,如果不这样转换一下,导出会报警告
export type BoxCutCssVarManager = GetCssVarManager<BoxCutBase>
export { BoxCutBase, BoxCutDefault }
type ScopedSlots = {
  /** 不会被裁剪的悬浮元素 */
  unCutSuspense: void
  /** 将被裁剪的悬浮元素 */
  cutSuspense: void
}
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<BoxCut>({
  name: 'BoxCut'
})
export default class BoxCut extends Mixins<
  Base<unknown, unknown, unknown, ScopedSlots>,
  BaseCssVarInject<BoxCutBase>
>(Base, BaseCssVarInject) {
  /** 取得cssVar 默认的 */
  public static getCssVarDefault = () => new BoxCutDefault()

  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>
  render() {
    return (
      <div
        // 标记日期 2024年5月13号 每张游戏卡片的完整信息挂载在卡片节点上,方便调试,将来会删除
        data-cardInfo={
          isDebug
            ? JSON.stringify(this.cardProps).replaceAll('"', "'")
            : undefined
        }
        class={{
          [style['box-cut']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        {/* theme-will-cut,准备废弃,后期请直接使用will-cut */}
        <div class={[style['will-cut'], 'theme-will-cut', 'will-cut']}>
          {this.$slots?.default}
          {/* 此处专门增加一个插槽,主要是为了使用时候更加语义化 */}
          {this.$scopedSlots?.cutSuspense?.()}
          {/* 用于模拟边框 */}
          <div
            class={{
              'cut-border': true,
              [style['cut-border']]: true
            }}
          ></div>
        </div>
        {this.$scopedSlots?.unCutSuspense?.()}
      </div>
    )
  }
}
